
import React from 'react';
import { CheckBox } from 'react-admin-base-bootstrap';
import {Col, FormText, Row} from "reactstrap";

export default function MultiSelectCheck({ id, value, onChange, fields }) {
    const _value = value || [];

    return <Row>
        { fields.map(a => <Col md="6" key={a.id} className={a.desc ? 'mb-3' : ''}>
            <CheckBox
                id={id + "_" + a.id}
                label={a.name}
                checked={_value.indexOf(a.id) !== -1}
                onChange={() => {
                    if (_value.indexOf(a.id) === -1) {
                        onChange(_value.concat([a.id]));
                    } else {
                        onChange(_value.filter(b => b !== a.id));
                    }
                }}
            />
            { a.desc && <FormText color="muted">{a.desc}</FormText>}
        </Col>)}
    </Row>
}